import { Form, Formik, FormikProps } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { useLocale } from '../../../contexts/localeContext';
import DefaultProfile from "../../../images/UserProfileDefault.svg";
import closeIcon from '../../../images/close.svg';
import { getMasterImages } from '../../../services/enrolmentService';
import { showError } from '../../../services/utilities/ServiceError';
import { appendFilter } from '../../../utilities/filters';
import ManuallyMusteringForm from './manually-mustering-form';
import { toast } from 'react-toastify';

interface ManuallyMusteringModalProps {
    item: any;
    isOpen: boolean;
    onSave: (values: any) => void;
    onClose: () => void;
    siteId: string;
}

const ManuallyMusteringModal: FC<ManuallyMusteringModalProps> = ({ item, isOpen, onSave, onClose, siteId }) => {
    const { translate } = useLocale();
    const [userProfileImage, setUserProfileImage] = useState<string>(DefaultProfile);

    useEffect(() => {
        if (item && item.id) {
            getUserImage();
        }
    }, [item]);

    const getUserImage = async () => {
        try {
            // Filter so that we only get primary image
            const userImages: string[] = await getMasterImages(item.id, { filters: appendFilter("1", "Image Type", "masterImageType.id", []) });
            if (userImages.length > 0) {
                setUserProfileImage(userImages[0]);
                return;
            }

            setUserProfileImage(DefaultProfile);
        }
        catch (error) {
            showError(error, toast.warn);
        }
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <Formik
            enableReinitialize={true}
            initialValues={item}
            onSubmit={onSave}>
            {(formik: FormikProps<any>) => {
                const {values } = formik;
                return <Form>
                    <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                        <div className="flex flex-row">
                            <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.mustering)}</p>
                        </div>
                        <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
                    </div>
                    <div className="flex flex-row pt-3 pl-1 pr-0 pb-3" style={{ width: '660px' }} >
                        <div className='felx flex-col px-2 w-1/3'>
                            <img alt='User Profile' className='rounded' src={userProfileImage} width={190} height={190} />
                        </div>
                        <div className='flex flex-col justify-between'>
                            <div className='flex flex-row'>
                                <ManuallyMusteringForm siteId={siteId} />
                            </div>
                            <div className='flex flex-row justify-end pl-4 py-4'>
                                <button
                                    onClick={onClose}
                                    className='justify-center pr-8 py-1 text-base sm:w-auto sm:text-sm border-transparent text-portal-blue-primary'>
                                    {translate.byKey(TranslationKeys.cancel)}
                                </button>
                                <button
                                    id='manuallyMusterBtn'
                                    className={`${values.musteringPointId ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'} secondary py-1 px-5`}
                                    disabled={!!!values.musteringPointId}
                                    type='submit'>
                                    {translate.byKey(TranslationKeys.manuallyMuster)}
                                </button>
                            </div>
                        </div>
                    </div>
                </Form>
            }
            }
        </Formik>
    </Modal>
}

export default ManuallyMusteringModal;